export enum CalendarEventActions {
    SelectionChanged,
    CreateReservation,
    CancelReservation,
    InActiveEventClicked,
    CancelMeeting,
    MoveMeeting,
}
